module.exports = __webpack_public_path__ + "img/undraw_horror_movie_3988.2d0138e7.svg";